export default __webpack_public_path__ + "static/media/dailyp.b5e27ad8.png";